<template>
  <div class="bg-white mobile-explore-detail">
    <div class="avatar f--c ">
      <div>
        <oss-img :src="bloggerObj.headImg" :width="24" :height="24" style="border-radius:50%"></oss-img>
      </div>
      <div class="info">
        <p class="name">{{bloggerObj.fullName}}<oss-img src="https://img.kakaclo.com/web-img/index/ins_icon.png" :width="7" :height="7"></oss-img>
        </p>
        <p class="follow">{{forMatNumber(bloggerObj.fansNum)}} <span style="color: #747A87;"> {{ $t('Index.MobileExploreDetail.Following') }}</span></p>
      </div>
    </div>
    <van-swipe class="my-swipe" :autoplay="0" indicator-color="white" @change="onChange">
      <van-swipe-item v-for="(item, index) in imgURL" :key="index">
        <!-- <img :src="item" alt="" style="width:100%;"> -->
        <oss-img :src="item" mType="lfit" :width="350" style="width:100%"></oss-img>
      </van-swipe-item>
    </van-swipe>
    <div class="blog-content">
      <div v-if="!showMore">
        <p class="product-name ellipsis2">{{insInfo.textContent}}</p>
        <span style="color:#99c41c" class="pointer" @click="showMore=true">{{ $t('Index.MobileExploreDetail.ViewMore') }}</span>
      </div>
      <div v-else>
        <p style="padding-bottom:5px">{{insInfo.textContent}}</p>
        <span style="color:#99c41c" class="pointer" @click="showMore=false">{{ $t('Index.MobileExploreDetail.PackUp') }}</span>
      </div>
    </div>
    <div class="like-comment f">
      <span class="color1 f--c"> <img src="@/assets/img/homePage/like.svg" alt="" lazy class="icons" />{{forMatNumber(insInfo.likeNum)}}</span>
      <span class="color1 f--c" style="margin-left:14px"><img src="@/assets/img/homePage/comment.svg" alt="" lazy class="icons" />{{forMatNumber(insInfo.commentNum)}} </span>
    </div>
    <div class="mobile-element">
      <h1>{{ $t('Index.MobileExploreDetail.ClothingElements') }}</h1>
      <div v-for="(item,index) in currentTagsGroup.boxLabelRetList" :key="index" class="elements">
        <div v-if="item.type1.length>0" class="elements-item f-b-c">
          <div class="category-title">
            <span v-for="(x,y) in item.type1" :key="y">{{upperFirst(getValue(x.tag))}}</span>
          </div>
        </div>
        <div v-if="item.type2.length>0" class="elements-item f-b-c">
          <h1>{{ $t('Index.MobileExploreDetail.Color') }}</h1>
          <div class="element-item-right">
            <span v-for="(x,y) in item.type2" :key="y" style="display:inline-block;width:0.46rem;height:0.46rem;border-radius:50%" :style="{background:x.color}"></span>
          </div>
        </div>
        <div v-if="item.type3.length>0" class="elements-item f-b-c">
          <h1>{{ $t('Index.MobileExploreDetail.Pattern') }}</h1>
          <div class="element-item-right">
            <span v-for="(x,y) in item.type3" :key="y">{{upperFirst(getValue(x.tag))}}</span>
          </div>
        </div>
        <div v-if="item.type4.length>0" class="elements-item f-b-c">
          <h1>{{ $t('Index.MobileExploreDetail.Material') }}</h1>
          <div class="element-item-right">
            <span v-for="(x,y) in item.type4" :key="y">{{upperFirst(getValue(x.tag))}}</span>
          </div>
        </div>
        <div v-if="item.type5.length>0" class="elements-item f-b-c">
          <h1>{{ $t('Index.MobileExploreDetail.Material') }}</h1>
          <div class="element-item-right">
            <span v-for="(x,y) in item.type5" :key="y">{{upperFirst(getValue(x.tag))}}</span>
          </div>
        </div>
        <div v-if="item.type8.length>0" class="elements-item f-b-c">
          <h1>{{ $t('Index.MobileExploreDetail.Excipients') }}</h1>
          <div class="element-item-right">
            <span v-for="(x,y) in item.type8" :key="y">{{upperFirst(getValue(x.tag))}}</span>
          </div>
        </div>
        <div v-if="item.type11.length>0" class="elements-item f-b-c">
          <h1>{{ $t('Index.MobileExploreDetail.Style') }}</h1>
          <div class="element-item-right">
            <span v-for="(x,y) in item.type11" :key="y">{{upperFirst(getValue(x.tag))}}</span>
          </div>
        </div>
        <div v-if="item.type12.length>0" class="elements-item f-b-c">
          <h1>{{ $t('Index.MobileExploreDetail.Gender') }}</h1>
          <div class="element-item-right">
            <span v-for="(x,y) in item.type12" :key="y">{{upperFirst(getValue(x.tag))}}</span>
          </div>
        </div>
        <div v-if="item.type13.length>0" class="elements-item f-b-c">
          <h1>{{ $t('Index.MobileExploreDetail.Contour') }}</h1>
          <div class="element-item-right">
            <span v-for="(x,y) in item.type13" :key="y">{{upperFirst(getValue(x.tag))}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <el-button type="primary" @click="clickDetailCamera" class="footer-button">
        <i class="iconfont icon-photo" :title="$t('Index.MobileExploreDetail.UploadAPicture')" /><span>&nbsp; {{ $t('Index.MobileExploreDetail.ShopSimilar') }}</span>
      </el-button>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import swipe from 'vant/lib/swipe'
import 'vant/lib/swipe/style'
// import swipeCell from 'vant/lib/swipe-cell'
import 'vant/lib/swipe-cell/style'
import swipeItem from 'vant/lib/swipe-item'
import 'vant/lib/swipe-item/style'
import { depthTraversal } from '@/util/tree'
export default {
  components: {
    'van-swipe': swipe,
    // 'van-swipe-cell': swipeCell,
    'van-swipe-item': swipeItem
  },
  data() {
    return {
      imgBlogList: [], // 所有图片
      imgURL: [], // 图片地址
      currentTagsGroup: [], // 当前信息
      bloggerObj: {}, // 博主信息
      insInfo: {},
      menuList: [], // 多层信息
      deepMenu: [], // 单层信息
      showMore: false
    }
  },
  created() {
    this.getInsTagMenu()
    this.getInsInfo()
  },
  mounted() {

  },
  computed: {
    getValue() {
      return (code) => {
        let value = ''
        this.deepMenu.forEach(item => {
          if (item.code === code) {
            value = item.value
          }
        })
        return value
      }
    },
    forMatNumber() {
      return (num) => {
        if (Number(num) > 1000000) {
          return `${(Number(num) / 1000000).toFixed(2)}M`
        } else if (Number(num) >= 1000) {
          return `${(num / 1000).toFixed(2)}K`
        } else {
          return num
        }
      }
    },
    upperFirst() {
      return (str) => {
        str = str.toLowerCase()
        return str.replace(/\b\w|\s\w/g, fw => {
          return fw.toUpperCase()
        })
      }
    }

  },

  methods: {
    onChange(index) {
      this.currentTagsGroup = this.imgBlogList[index]
      this.getTags()
    },

    clickDetailCamera() {
      // e.stopPropagation()
      sessionStorage.removeItem('similar_base64')
      sessionStorage.setItem('similar_img', this.currentTagsGroup.imgUrl)
      this.$nextTick(() => {
        // this.$router.push('/mall/similar')
        window.open(`${window.location.origin}/mall/similar`)
      })
    },
    // 获取筛选菜单
    getInsTagMenu() {
      API.getInsTagMenu().then(res => {
        this.menuList = res.data
        let arr = []
        depthTraversal(res.data, item => {
          arr.push(item)
        }, 'childList')
        this.deepMenu = arr
      })
    },
    getInsInfo() {
      API.getInsInfo({ blogId: this.$route.query.id }).then(res => {
        if (res.data.imgBlogList && res.data.imgBlogList.length > 0) {
          this.imgBlogList = res.data.imgBlogList
          this.imgURL = res.data.imgBlogList.map(item => item.imgUrl)
          this.currentTagsGroup = res.data.imgBlogList[0]
          this.getTags()
        }
        this.insInfo = res.data
        this.bloggerObj = res.data.bloggerObj
        console.log(this.bloggerObj)
        this.bloggerObj.blogTime = this.bloggerObj.blogTime.split(' ').reverse().join(' ')
      })
    },
    getTags() {
      this.currentTagsGroup.boxLabelRetList.forEach(item => {
        item.type1 = []
        item.type2 = []
        item.type3 = []
        item.type4 = []
        item.type5 = []
        item.type6 = []
        item.type7 = []
        item.type8 = []
        item.type9 = []
        item.type10 = []
        item.type11 = []
        item.type12 = []
        item.type13 = []
        item.finalLabelArray.forEach(x => {
          if (x.type === 1) { item.type1.push(x) }
          if (x.type === 2) { item.type2.push(x) }
          if (x.type === 3) { item.type3.push(x) }
          if (x.type === 4) { item.type4.push(x) }
          if (x.type === 5) { item.type5.push(x) }
          // if (x.type === 6) { item.type6.push(x) }
          // if (x.type === 7) { item.type7.push(x) }
          if (x.type === 8) { item.type8.push(x) }
          // if (x.type === 9) { item.type9.push(x) }
          // if (x.type === 10) { item.type10.push(x) }
          if (x.type === 11) { item.type11.push(x) }
          if (x.type === 12) { item.type12.push(x) }
          if (x.type === 13) { item.type13.push(x) }
        }
        )
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-explore-detail {
  min-height: 100vh;
  padding: 0.4rem 0.3rem 1.3rem;
  .avatar {
    margin-bottom: 0.4rem;

    .info {
      margin-left: 0.1rem;
      font-weight: 400;
      color: #000000;
      .name {
        line-height: 0.4rem;
        font-size: 0.28rem;
      }
      .follow {
        font-size: 0.24rem;
      }
    }
  }
  .blog-content {
    margin: 0.4rem 0;
  }
  .like-comment {
    margin-bottom: 0.86rem;
    img {
      display: inline-block;
      width: 0.32rem;
      height: 0.32rem;
      margin-right: 0.1rem;
      font-weight: 400;
      font-size: 0.28rem;
      line-height: 0.4rem;
      color: #000000;
    }
  }
  .mobile-element {
    h1 {
      font-weight: 600;
      font-size: 0.32rem;
      line-height: 0.46rem;
      color: #000000;
      margin-bottom: 0.46rem;
    }
    .elements {
      margin-bottom: 0.4rem;
      .category-title {
        font-weight: 600;
        font-size: 16px;
        line-height: 23px;
        color: #000000;
      }
      .elements-item {
        margin-bottom: 0.3rem;
        h1 {
          font-weight: 400;
          font-size: 0.28rem;
          line-height: 0.42rem;
          color: #000000;
          margin-bottom: 0;
        }
        .element-item-right {
          span {
            display: inline-block;
            margin-left: 0.1rem;
            font-weight: 400;
            font-size: 0.28rem;
            line-height: 0.42rem;
            color: #747a87;
            border: 0.5px solid #cdd4dd;
            border-radius: 4px;
            padding: 0.1rem;
          }
        }
      }
    }
  }
  .footer {
    position: fixed;
    background: #fff;
    bottom: 0;
    padding-bottom: 6px;
    .footer-button {
      width: calc(100vw - 0.6rem);
      height: 0.9rem;
      border-radius: 0.12rem;
    }
  }
}
</style>
